import ListingsRoutingResolver from './ListingRoutingResolver';

class SuppliersListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "supplier"
    }
}

export default SuppliersListingResolver
